import { ExistingUser, RoleId } from "@store/generalTypes";

export const getUsersByRole = (users: ExistingUser[], role: RoleId, location?: number): ExistingUser[] => {
    const prevEmpty: ExistingUser[] = [];

    const filteredUsers = users.reduce((prev, curr) => {
        const isRole = curr.locations?.some(
            (x) => (!location || x.id === location) && x.roles?.map((r) => r.id).includes(role)
        );

        if (isRole) {
            return prev.concat(curr);
        } else {
            return prev;
        }
    }, prevEmpty);

    return filteredUsers;
};
